export function validateDNI(value: string): boolean {
  const clean = value.replace(/\D/g, "");
  return clean.length >= 7 && clean.length <= 8;
}

export function validateCUIT(value: string): boolean {
  const clean = value.replace(/\D/g, "");
  if (!/^\d{11}$/.test(clean)) return false;

  const multipliers = [5,4,3,2,7,6,5,4,3,2];
  let sum = 0;

  for (let i = 0; i < 10; i++) {
    sum += parseInt(clean[i], 10) * multipliers[i];
  }

  const mod = sum % 11;
  const checkDigit = mod === 0 ? 0 : mod === 1 ? 9 : 11 - mod;

  return checkDigit === parseInt(clean[10], 10);
}

export function validateArgentinaId(value: string): boolean {
  const clean = value.replace(/\D/g, "");

  // DNI (7–8 dígitos)
  if (validateDNI(clean)) return true;

  // CUIT / CUIL (11 dígitos con checksum)
  if (validateCUIT(clean)) return true;

  return false;
}
